



























import Vue from 'vue'
import ButtonEl from '@/components/elements/ButtonEl.vue'
import { WhiteButtonElInterface } from '@/config/interfaces'

export default Vue.extend({
  name: 'WhiteButtonEl',

  data: () => ({
    imgError: false
  }),

  components: { ButtonEl },

  computed: {
    bgColor (): string {
      return `background-color: ${this.templateItemData.background || 'transparent'};`
    }
  },

  props: {
    templateItemData: {
      type: Object as () => WhiteButtonElInterface,
      required: true
    }
  }
})
